import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DefaultcaseService } from "../shared/defaultcase.service";

import { ConfirmationdialogService } from "../../../utility/shared/confirmationdialog.service";
import { ToasterserviceService } from "../../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../../utility/shared/toastpayload";

@Component({
  selector: 'app-defaultcaselist',
  templateUrl: './defaultcaselist.component.html',
  styleUrls: ['./defaultcaselist.component.css']
})

export class DefaultcaselistComponent implements OnInit {

  displayedColumns: string[] = ['CustomerName', 'LoanId', 'SavingsId', 'DefaultFrom', 'LoanBalance', 'SavingsBalance', 'New'];

  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  toast: Toastpayload;

  constructor(private defaultcaseService: DefaultcaseService,
    private router: Router,
    private toasterserviceService: ToasterserviceService,
    private confirmationdialogService: ConfirmationdialogService,) { }

  ngOnInit() {

    this.getInstallmentChangeList();
    this.dataSource.paginator = this.paginator;
  }

  public AddNew() {

    this.router.navigate(['/defaultcase']);
  }

  getInstallmentChangeList() {

    this.defaultcaseService.FetchDefaultCaseList().subscribe(data => {
      this.dataSource.data = data;
    })
  }

  Edit(Savings: any) {

    this.router.navigate(['/defaultcase', Savings.SavingsId]);
  }

  applyFilter(filterValue: string) {

    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  // Delete with Toastr messsage
  Delete(str: string, Savings: any) {

    this.toast = {
      message: "The default case have been deleted",
      title: 'Default case deletion',
      ic: {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };

    let title: string = "Confirmation";
    let message: string = "If you continue, the default case will be removed. Are you sure? ";
    let btnOkText: string = "Yes";
    let btnCancelText: string = 'No, Exit';

    this.confirmationdialogService.openModalWithClass(title, message, btnOkText, btnCancelText)
      .subscribe(confirmed => {
        if (confirmed == true) {
          this.IUDDefaultcase(Savings);
        }
        else {
          this.toast.message = 'You are cancelled the default case deletion.!'
          this.toast.type = 'warning';
          this.toasterserviceService.showToast(this.toast);
        }
      });
  }

  // Default case action
  IUDDefaultcase(Defaultcase: any) {

    Defaultcase.Flag = 3; // deactivate Flag
    // IUD action
    this.defaultcaseService.IUDDefaultChange(Defaultcase)
      .toPromise()
      .then(data => {
        this.router.navigate(['/defaultcaselist']);
      })
  }

}
